class PagoSinFactura {
    constructor(idLiquidacion, fechaRegistro, fechaRegistroFormateada, fechaVto, fechaVtoFormateada, nroRecibo, procesoJudicial, formaPago,importe,idJuicio){
      this.idLiquidacion=idLiquidacion
      this.fechaRegistro=fechaRegistro
      this.fechaRegistroFormateada=fechaRegistroFormateada
      this.fechaVto=fechaVto
      this.fechaVtoFormateada=fechaVtoFormateada
      this.nroRecibo=nroRecibo
      this.procesoJudicial=procesoJudicial
      this.formaPago=formaPago
      this.importe=importe
      this.idJuicio=idJuicio
    } 
  }
  
  export default PagoSinFactura
  